import React, { Component } from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getForm } from 'react-formio';

import View from './View';
import Edit from './Edit';
import Delete from './Delete';

class Item extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        formId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getForm: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      formId: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.match.params.formId !== prevState.formId) {
      nextProps.getForm(nextProps.match.params.formId);
    }

    return {
      formId: nextProps.match.params.formId,
    };
  }

  render() {
    const {match: {params: {formId}}} = this.props;
    return (
      <div>
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <Link className="nav-link" to="/form">
              <i className="fa fa-chevron-left"></i>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`/form/${formId}/edit`}>
              <i className="fa fa-edit"></i> Edit Form
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`/form/${formId}/delete`}>
              <i className="fa fa-trash"></i> Delete Form
            </Link>
          </li>
        </ul>
        <Switch>
          <Route exact path="/form/:formId" component={View} />
          <Route path="/form/:formId/edit" component={Edit} />
          <Route path="/form/:formId/delete" component={Delete} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getForm: (id) => dispatch(getForm('form', id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Item);
